export const data = {
      lock: {
        "icon":"fa fa-lock",
        "verbose":"lock",
        "props":{
          type:"boolean",
          title:"locking pin to user",
          default:true
        }
      },
      range: {
        "icon":"fa fa-sliders",
        "verbose":"range",
        "props":{
          type:"object",
          title:"Maxvalue",
          minLength:5,
          maxLength:5        
        }
      },
      group:{
        "icon":"fa fa-user",
        "verbose":"speaker",
        "props":{
          type:"integer",
          title:"Pin per speaker",
          maxLength:2,
          minLength:1,
        }
      },
    }

export const schema_default = {
      title: "",
      type: "object",
      required: [
        "count",
      ],
      properties: {
        count: {
          type: "integer",
          title: "Number of pins"
        },
        maxlength: {
          type: "integer",
          title: "Max recording length"
        },
        pid: {
          type: "integer",
          title: "Project ID"
        }
      }
    }

export const uiSchema = {
      lock: {
        "ui:disabled":"true"
      },
      range: {
        "ui:field":"pinner"
      },
      pid: {
      "ui:widget":"hidden"
      }
    }


// WEBPACK FOOTER //
// ./src/views/projects/constants.js